export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9784.5a31e78a.jpg";